<template>
  <div>
    <b-form inline class="mb-2">
      <b-input-group>
        <b-input-group-prepend is-text>
          <font-awesome-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input :value="filter" @input="$emit('update:filter', $event)" placeholder="Type to Search" class="filter-input"></b-form-input>
        <b-input-group-append>
          <b-button class="btn" @click="filter = null">Clear</b-button>
        </b-input-group-append>
      </b-input-group>

      <slot name="buttons"></slot>
    </b-form>

    <slot name="content"></slot>

    <b-pagination :total-rows="totalRows" :value="currentPage" @input="$emit('update:currentPage', $event)" :per-page="perPage" align="right" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    perPage: {
      type: Number,
      required: false,
      default: 20
    },

    totalRows: {
      type: Number,
      required: false,
      default: 0
    },
    filter: {
      type: String,
      required: false,
      default: null
    },

    currentPage: {
      type: Number,
      required: false,
      default: 1
    }
  }
};
</script>

<style scoped>
.widget-body,
select {
  font-size: 13px;
}

.filter-group {
  margin-bottom: 15px;
  max-width: 600px;
}

.align-right {
  text-align: right;
}
</style>
